import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

/**
 * Tab de Exames de Dan.
 *
 * Props:
 *  - affiliate: objeto atual
 *  - onAdd: callback pra abrir dialog de novo exame
 *  - onEdit(danExam): callback pra editar
 *  - onDelete(danExam): callback pra remover
 */
export function TabDanExams({ affiliate, onAdd, onEdit, onDelete }) {
    const { t } = useTranslation();

    const actionBodyTemplate = (rowData) => (
        <>
            <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2"
                onClick={() => onEdit(rowData)} />
            <Button icon="pi pi-trash" className="p-button-rounded p-button-danger"
                onClick={() => onDelete(rowData)} />
        </>
    );

    return (
        <>
            <p></p>
            <label htmlFor="name">{affiliate.name}</label>
            <p></p>
            <DataTable value={affiliate.danExams} responsiveLayout="scroll">
                <Column field="danId" header={t('msg.jkaDan')} sortable style={{ minWidth: '1rem' }} />
                <Column field="date" header={t('msg.jkaExamDate')} sortable style={{ minWidth: '2rem' }} />
                <Column field="record" header={t('msg.jkaLicenseRegistrationId')} sortable style={{ minWidth: '6rem' }} />
                <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '8rem' }} />
            </DataTable>
            <p></p>
            <Button icon="pi pi-plus-circle" iconPos="right" onClick={onAdd} />
        </>
    );
}
